import { render, staticRenderFns } from "./RouteViewSidebar.vue?vue&type=template&id=5aae6a16&scoped=true&"
import script from "./RouteViewSidebar.vue?vue&type=script&lang=js&"
export * from "./RouteViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RouteViewSidebar.vue?vue&type=style&index=0&id=5aae6a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aae6a16",
  null
  
)

export default component.exports